import React from "react";
import { connect } from "formik";
import { compose } from "redux";
import { Grid } from "@material-ui/core";

import { Divider, StyledGridContainer, StyledFormikInputPercent, StyledFormikInputText, StyledFormikInputTypeAhead, StyledHeaderContainer, StyledHeader, StyledTermSheetButonBlueSM, StyledButtonCenteredSM } from "./section.styles";
import { addScheduleRow, setInitialPrepaymentSchedule, renderPrepaymentSchedules } from "./section.util";

const Prepayment = ({ formik }) => {
  const { values, setValues } = formik;

  const prepaymentTypes = values && values.ancillary && values.ancillary.prepaymentTypes ? values.ancillary.prepaymentTypes : [];

  return (
    <Grid container>
      <StyledHeaderContainer item xs={12}><StyledHeader>Prepayment</StyledHeader></StyledHeaderContainer>

      <StyledGridContainer item xs={6}>
        <StyledFormikInputTypeAhead
          id="prepaymentTypeId"
          name="prepaymentTerms.prepaymentTypeId"
          label="Prepayment Type"
          options={prepaymentTypes}
          displayWith={option => option && option.name}
          setValueWith={option => option && option.id}
          onChange={value => {
            setInitialPrepaymentSchedule(values, value, setValues);
          }}
          className="input"
          variant={"filled"}
        />
      </StyledGridContainer>
      <StyledGridContainer item xs={1} />
      <StyledGridContainer item xs={5}>
        <StyledFormikInputPercent
          name={"prepaymentTerms.exitFee"}
          label={"Exit Fee (%)"}
          decimals={3}
          variant={"filled"}
        />
      </StyledGridContainer>

      <StyledGridContainer item xs={12}>
        <StyledFormikInputText
          name={"prepaymentTerms.other"}
          label={"Miscellaneous"}
          variant={"filled"}
          multiline
        />
      </StyledGridContainer>

      <Divider />

      <StyledHeaderContainer item xs={6}>
        <StyledHeader>Prepayment Schedule</StyledHeader>
      </StyledHeaderContainer>

      <StyledTermSheetButonBlueSM
        onClick={() => addScheduleRow(values, setValues)}
      >
        <StyledButtonCenteredSM>Add a Row</StyledButtonCenteredSM>
      </StyledTermSheetButonBlueSM>

      {renderPrepaymentSchedules(values, setValues)}
      <Divider />
    </Grid>
  );
};

export default compose(connect)(Prepayment);
